import { Router } from '@angular/router';
import { Component, AfterViewInit, OnDestroy, ViewChild, ViewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IUserInfo } from '../../shared/models';
import { LocationPickerComponent } from '../../shared/ui';
import { SelectionItem } from 'ng2-material-components/ng2-material-components';
import { AppPageComponent } from '../../shared/ui';
import { TopLevelComponent } from '../../shared/models';
import { StoreHelper, Store, UserService } from '../../shared/services';
import { Subscription } from 'rxjs/Subscription';

@Component({
    styles: [ require('./transfer-locations.component.scss') ],
    template: require('./transfer-locations.component.pug')
})
export class TransferLocationsComponent extends TopLevelComponent implements AfterViewInit, OnDestroy {
    @ViewChild(AppPageComponent) appPage;
    @ViewChildren(LocationPickerComponent) inputFilterSheetComponents;

    regionsOrigin: SelectionItem[];
    locationsOrigin: SelectionItem[] = [];
    locationOriginId: number;
    regionOriginId: number;
    locationOriginError: boolean = false;

    regionsDestination: SelectionItem[];
    locationsDestination: SelectionItem[] = [];
    locationDestinationId: number;
    regionDestinationId: number;
    locationDestinationError: boolean = false;

    private _user: IUserInfo;
    private _userSubs: Subscription;
    fg = new FormGroup({});

    constructor(
                public _router: Router,
                _store: Store,
                _storeHelper: StoreHelper,
                _userSvc: UserService
               ) {
          super(_store, _storeHelper, _userSvc);
          this.headerTitle = 'Transfer';
          this.headerActions = [];
          this._userSubs = _userSvc.user$
                .do(user => this._user = user)
                .subscribe(user => this._refreshRegions(user));
    }


  ngAfterViewInit() {

      this.fg.controls['regionOrigin'].valueChanges
            .subscribe(regionId => {
                this.fg.controls['locationOrigin'].setValue('');
                this.regionOriginId = regionId;
                this._updateOriginLocations(regionId);
            } );

      this.fg.controls['regionDestination'].valueChanges
            .subscribe(regionId => {
                this.fg.controls['locationDestination'].setValue('');
                this.regionDestinationId = regionId;
                this._updateDestinationLocations(regionId);
            });

      this.fg.controls['locationOrigin'].valueChanges
            .subscribe(locationId => {
                if (locationId) {
                    this.locationOriginId = locationId;
                   this._updateDestinationLocations(this.regionOriginId);
                }
            });

      this.fg.controls['locationDestination'].valueChanges
            .subscribe(locationId => {
                if (locationId) {
                    this.locationDestinationId = locationId;
                    this._updateOriginLocations(this.regionDestinationId);
                }
            });

      this.appPage.deactivatePreloader();
  }

  ngOnDestroy() {
    this._userSubs.unsubscribe();
  }

   goToSelectProducts(e: MouseEvent) {
        e.preventDefault();

        this.locationDestinationError = false;
        this.locationOriginError = false;

        if (!this.locationOriginId ) {
                this.locationOriginError = true;
                return;
        }

        if (!this.locationDestinationId) {
                this.locationDestinationError = true;
                return;
        }

        this._router.navigate(['/inventory/trasfer-products', this.locationDestinationId, this.locationOriginId]);
    }

  private _refreshRegions(user: IUserInfo) {
    if (!user || !user.regions) {
      return;
    }

    let regions = user.regions.map(region => {
      return new SelectionItem(region.id, region.name);
    });

    this.regionsDestination = regions;
    this.regionsOrigin = regions;
  }
  private _updateOriginLocations(regionId: number) {
    this.locationsOrigin = this._filteredLocations(regionId, this.locationDestinationId, this.locationOriginId);
  }

  private _updateDestinationLocations(regionId: number) {
        this.locationsDestination = this._filteredLocations(regionId, this.locationOriginId, this.locationDestinationId);
  }

  private _filteredLocations(regionId: number, locationToFilterId: number, locationIdSelected: number): Array<SelectionItem> {
      let filteredLocations = this._user.regions
                    .find(region => region.id === +regionId).locations
                    .filter(l => l.id !== +locationToFilterId);
      return filteredLocations.map(location => new SelectionItem(location.id, location.name, location.id === +locationIdSelected));
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/transfer-locations/transfer-locations.component.ts